import React from 'react';
import '../styling/SupportPage.css';

function SupportPage() {
  return (
    <div className="support-container">
      <h1>Support</h1>
      <p>
        If you have any questions or need assistance with our services, please use the resources provided below.
      </p>
      <p>
        We value your feedback and are committed to ensuring that your experience with Kyro Studios is outstanding.
        Check back often for updates and new features.
      </p>
      {/* Additional support components or a contact form can be added here */}
    </div>
  );
}

export default SupportPage;
